import React from 'react';
import { DollarSign, AlertTriangle, TrendingDown } from 'lucide-react';

const BalanceDisplay = ({ balance, balanceFormatted, onTopUp, isLowBalance = false }) => {
  const isNegative = balance < 0;

  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 border ${isLowBalance ? 'border-yellow-300' : isNegative ? 'border-red-300' : 'border-gray-200'}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600 mb-1">Account Balance</p>
          <div className="flex items-center gap-2">
            <p className={`text-4xl font-bold ${isNegative ? 'text-red-600' : isLowBalance ? 'text-yellow-600' : 'text-freshroad-black'}`}>
              {balanceFormatted || '$0.00'}
            </p>
            {isNegative && (
              <span className="flex items-center gap-1 text-sm text-red-600 bg-red-50 px-2 py-1 rounded">
                <TrendingDown className="w-4 h-4" />
                Negative
              </span>
            )}
          </div>
          {isLowBalance && !isNegative && (
            <p className="text-sm text-yellow-600 mt-2 flex items-center gap-1">
              <AlertTriangle className="w-4 h-4" />
              Low balance - consider adding funds
            </p>
          )}
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className={`p-3 rounded-lg ${isNegative ? 'bg-red-100' : isLowBalance ? 'bg-yellow-100' : 'bg-freshroad-gradient-teal'}`}>
            <DollarSign className={`w-6 h-6 ${isNegative ? 'text-red-600' : isLowBalance ? 'text-yellow-600' : 'text-freshroad-teal'}`} />
          </div>
          <button
            onClick={onTopUp}
            className="px-4 py-2 bg-freshroad-teal text-white rounded-lg hover:bg-freshroad-teal-dark transition-colors font-medium"
          >
            Add Funds
          </button>
        </div>
      </div>
    </div>
  );
};

export default BalanceDisplay;
